import { IMG_BASE_URL } from "src/config/constants";
import ImageViewer from "../lib/image-viewer/ImageViewer";

const CellImage = ({ src, size = 60, style = {}, preview = false }) => {
  if (!src) return null;
  if (src.includes(',')) {
    src = src.split(',')[0];
  }

  let hasPrefix = false;

  if (src.startsWith('https:')) {
    hasPrefix = true;
  }

  function handleImageClick() {
    ImageViewer({
      images: [`${hasPrefix ? '' : IMG_BASE_URL}${src}`]
    })
  }

  return <img src={`${hasPrefix ? '' : IMG_BASE_URL}${src}?w=${size}`} style={{ maxWidth: size, maxHeight: size, ...style }} onClick={handleImageClick}/>;
};

export default CellImage;
